import { takeLatest, put, select, call } from 'redux-saga/effects';
import { deleteTxnOpps, setClientTxnOpps, fetchQueueTxnOppsData, setChannelWorkflowLoadingOverlayState, appNotify, setPropertyUWClientTxnOpp } from 'store/actions';
import { clientTxnOppsSelector, queueBinsStateSelector, showPostAcquisitionsSelector, userSelector } from 'store/selectors';
import { postWithToken } from 'api/network';
import { configureQueueBinsState } from 'sagas/getQueueTxnOppsDataSaga';
import { Constants } from 'utilities/constants';

export function* deleteTxnOppsSaga() {
    yield takeLatest(deleteTxnOpps, function* ({ payload: txnOppIds }) {
        try {
            const user = yield select(userSelector);
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Deleting...' }));
            const res = yield postWithToken(`/api/underwrite/workflow/opportunity/delete?requestUserId=${user.id}`, txnOppIds);
            const deletedTxnOppIds = yield res.json();

            // Remove txnOpps from client side
            const clientTxnOpps = yield select(clientTxnOppsSelector);
            if (clientTxnOpps) {
                let foundDeletedRows = false;
                const newClientTxnOpps = [...clientTxnOpps];
                deletedTxnOppIds.forEach(txnOppId => {
                    const oppToDeleteIndex = newClientTxnOpps.findIndex(x => x.id === txnOppId);
                    if (oppToDeleteIndex > -1) {
                        foundDeletedRows = true;
                        newClientTxnOpps.splice(oppToDeleteIndex, 1);
                    }
                })

                if (foundDeletedRows) {
                    yield put(setClientTxnOpps(newClientTxnOpps));

                    const queueBinsState = yield select(queueBinsStateSelector, Constants.Module.UNDERWRITE);
                    const showPostAcquisitions = yield select(showPostAcquisitionsSelector);
                    const newQueueBinsState = yield call(configureQueueBinsState, Constants.Module.UNDERWRITE, newClientTxnOpps, showPostAcquisitions);
                    if (queueBinsState.allTasks.areSame(newQueueBinsState.allTasks)) {
                        yield put(fetchQueueTxnOppsData(Constants.Module.UNDERWRITE));
                    }
                }
            }
            // clear selectedTxnOpp
            yield put(setPropertyUWClientTxnOpp(null))
        } catch (error) {
            yield put(appNotify(error.message, 'error'));
        }
        finally {
            yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
        }
    });
}
